import React, { useState } from "react";

import {
    LabeledField,
    LanguageSegmentedControl,
    SectionCard,
    Stack,
    TextInput,
    Textarea,
} from "shared/ui";

import { useMenuSettingsContext } from "features/MenuSettings/context";

import { ContactsCard } from "./components/ContactsCard";
import { WorkingScheduleCard } from "./components/WorkingScheduleCard";

export const GeneralTab = () => {
    const { general, menuFlags, locale } = useMenuSettingsContext();
    const [activeLang, setActiveLang] = useState<string>(locale);

    return (
        <>
            <SectionCard
                title="Название и адрес"
                headerRight={
                    <LanguageSegmentedControl
                        languages={menuFlags.enabledLocales}
                        activeLang={activeLang}
                        primaryLang={locale}
                        onChange={setActiveLang}
                        isMissing={(lang) => !general.name[lang]}
                    />
                }
            >
                <Stack>
                    <LabeledField label="Название">
                        <TextInput
                            value={general.name[activeLang]}
                            onChange={(value) => general.setLocalizedName(value, activeLang)}
                            placeholder="Например, Кофейня на Ленина"
                        />
                    </LabeledField>

                    <LabeledField
                        label="Описание"
                        hint="Гость видит описание на главной меню"
                    >
                        <Textarea
                            value={general.description[activeLang]}
                            onChange={(value) =>
                                general.setLocalizedDescription(value, activeLang)
                            }
                            placeholder="Чем вы отличаетесь от других"
                            rows={4}
                        />
                    </LabeledField>

                    <LabeledField label="Город">
                        <TextInput
                            value={general.region[activeLang]}
                            onChange={(value) => general.setLocalizedRegion(value, activeLang)}
                            placeholder="Москва"
                        />
                    </LabeledField>

                    <LabeledField label="Адрес">
                        <TextInput
                            value={general.addressTitle[activeLang]}
                            onChange={(value) =>
                                general.setLocalizedAddressTitle(value, activeLang)
                            }
                            placeholder="улица Ленина, 1"
                        />
                    </LabeledField>

                </Stack>
            </SectionCard>

            <ContactsCard />
            <WorkingScheduleCard />
        </>
    );
};
